import React from 'react';
import EnhancedHero from '../components/Enhanced/EnhancedHero';
import ServiceCards from '../components/ServiceCards';
import TaxSeasonClosedBanner from '../components/TaxSeasonClosedBanner';
import NEABestBanner from '../components/NEABestBanner';
import WealthManagementSection from '../components/WealthManagementSection';
import ServicesSection from '../components/ServicesSection';
import BlogSection from '../components/BlogSection';
import TeamSection from '../components/TeamSection';
import TaxesToGoSection from '../components/TaxesToGoSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <>
      <EnhancedHero />
      <TaxSeasonClosedBanner />
      <ServiceCards />
      <NEABestBanner />
      <WealthManagementSection />
      <ServicesSection />
      <BlogSection />
      <TeamSection />
      <TaxesToGoSection />
      <ContactSection />
    </>
  );
};

export default HomePage;